module.exports = __webpack_public_path__ + "img/ML 12 - Ground.1a831728.jpg";